export default __webpack_public_path__ + "static/media/pdf-icon.50434dc1.svg";